import { render, staticRenderFns } from "./privateDokumen.vue?vue&type=template&id=6fb9ad5e&"
import script from "./privateDokumen.vue?vue&type=script&lang=js&"
export * from "./privateDokumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QPagination,QDialog,QCardActions,QFile,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QPagination,QDialog,QCardActions,QFile}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
